module.exports = __webpack_public_path__ + "static/media/planta2.155d6a8e.png";